import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeSidebar, openSidebar } from "../../features/sidebarSlice";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Background from "../../assets/icons/hexagon.svg";
import { Turn as Hamburger } from "hamburger-react";
import { FiArrowLeft } from "react-icons/fi";
import { useMutation } from "react-query";
import { detailsCompany } from "../../api/methods/Company";
import { prefix } from "../../api/ApiConstants";
import { ClipLoader } from "react-spinners";
import { MdOutlineImageNotSupported } from "react-icons/md";
import SettingsMenu from "./components/SettingsMenu";
import NotificationsMenu from "./components/NotificationsMenu";
import ProfileMenu from "./components/ProfileMenu";
import ChangeTheme from "./components/ChangeTheme";
import SearchStockHolders from "./components/SearchStockHolders";
import CreditComponent from "./components/CreditComponent";
import ExitComponent from "./components/ExitComponent";
import { setInsCode } from "../../features/insCodeSlice";
import { setDetails } from "../../features/detailsSlice";
import { isMobile } from "react-device-detect";

const Header = () => {
  const hasPermission = useSelector(
    (state) => state?.data?.Permission?.JustCreateStockRightPaper
  );
  const location = useLocation();
  const dispatch = useDispatch();
  const isSidebarOpen = useSelector((state) => state["sidebar"].isSidebarOpen);
  const CompanyId = useSelector((state) => state?.data?.RelatedCompanyId);
  const navigate = useNavigate();
  const [companyDetail, setCompanyDetail] = useState([]);

  const companyDetails = useMutation(["companyDetails", CompanyId], {
    mutationFn: detailsCompany,
    onSettled: (response) => {
      setCompanyDetail(response?.data?.data?.companies?.[0]);
      dispatch(setInsCode(response?.data?.data?.companies?.[0]?.InsCode));
      dispatch(setDetails(response?.data?.data?.companies?.[0]));
    },
  });

  const getCompanyDetails = async () => {
    await companyDetails.mutateAsync({
      data: {
        CompanyId,
      },
    });
  };

  useEffect(() => {
    getCompanyDetails();
  }, []);

  const showBackButton = location.pathname !== "/";

  return (
    <header className="z-50 py-2 relative bg-brand dark:bg-white border-b-2 border-b-borderSolid">
      <div
        className="absolute w-full h-full top-0 left-0 bg-no-repeat bg-cover opacity-60 -z-30"
        style={{ backgroundImage: `url(${Background})` }}
      />
      <div className="flex items-center gap-x-2 sm:gap-x-6 md:px-6 justify-between h-full mx-auto text-white dark:text-title">
        <button className="p-1 mr-2 md:hidden icon" aria-label="Menu">
          <Hamburger
            toggled={isSidebarOpen}
            toggle={() =>
              isSidebarOpen ? dispatch(closeSidebar()) : dispatch(openSidebar())
            }
            size={24}
            direction="left"
            label="منو"
            rounded
            distance="sm"
          />
        </button>
        <Link
          className="flex items-center h-12 mx-auto md:m-0 justify-center gap-x-2"
          to="/"
        >
          {!companyDetails.isLoading ? (
            companyDetails?.data?.data?.data?.companies?.[0]?.Logo ? (
              <img
                className="h-full border p-1 border-borderSolid rounded-md"
                src={`${
                  prefix + companyDetails?.data?.data?.data?.companies?.[0]?.Logo
                }`}
              />
            ) : (
              <MdOutlineImageNotSupported size={48} />
            )
          ) : (
            <ClipLoader size={32} color="var(--White)" />
          )}
          <h1 className="text-xs sm:text-xl font-medium whitespace-nowrap">
            {companyDetail?.Title}
          </h1>
        </Link>
        {showBackButton && (
          <div
            className="p-1 ml-2 active:opacity-70 flex md:hidden"
            onClick={() => {
              dispatch(closeSidebar());
              navigate(-1);
            }}
          >
            <FiArrowLeft color="#fff" size={24} />
          </div>
        )}
        {!isMobile && (
          <div className="flex items-center justify-center gap-x-12">
            <div className="flex items-center flex-shrink-0 gap-x-6">
              <CreditComponent />
              {hasPermission ? null : (
                <>
                  <SearchStockHolders />
                  <SettingsMenu />
                  <NotificationsMenu />
                </>
              )}
              <ProfileMenu />
              <ChangeTheme />
              <ExitComponent />
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default React.memo(Header);
